// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"79d655b2","63":"23e7b248","193":"0e9c0d0a","270":"0e1fb5fa","302":"51826b34","319":"ac42ca14","364":"364590a1","453":"ec3ecd73","717":"4b8786ac","794":"95e16a6d","985":"e121cee5"}[chunkId] + ".chunk.js";
};